import React from "react";
import { useState, useEffect, useRef } from "react";
import axiosAuth from "../Axios/Interceptors";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
type Props = {
  ScreenID: number;
  MainTopFiltersCallBack: any;
};
function MainTopFilters(props: Props) {
  const [scorecardFiltersData, setScorecardFiltersData] = useState<any>({
    StatusData: [],
    Dealers: [],
    Years: [],
    Quarter: [],
  });

  const [showAnimation, setShowAnimation] = useState(false)
  
  if (props.ScreenID !== -3000) {
    AppContext.ScoreCardFiltersIDs = {
      Dealers: 0,
      Years: 0,
      Quarter: 0,
      ScreenID: 0,
    };
  }

  const [selectedId, setSelectedId] = useState({
    ...AppContext.ScoreCardFiltersIDs,
  });
  
  const prevYear = useRef();
  const prevQuarter = useRef();
  const prevDealers = useRef();
  useEffect(() => {
    getLoadFilters();
  }, [selectedId.Dealers, selectedId.Years, selectedId.ScreenID]);

  useEffect(() => {
    sendResponseToParent();
  }, [selectedId.Quarter]);

  function habdleFilterChange() {
    // first update dealerid and year id in centerler variable
    //now call load the filters
  }

  function getLoadFilters() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.sc = selectedId.ScreenID;
    object.sdid = selectedId.Dealers;
    object.syid = selectedId.Years;
    object.sqid = selectedId.Quarter;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/PFIIBBDealerStatusData/GetLoadFilters",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          setScorecardFiltersData((prevState: any) => ({
            ...prevState,
            StatusData: l_response[0],
            Dealers: l_response[1],
            Years: l_response[2],
            Quarter: l_response[3],
          }));

          if (l_response[0]) {
            selectedId.Years = l_response[0][0].SelectedYear;
            selectedId.Quarter = l_response[0][0].SelectedQuarter;
            if(scorecardFiltersData.StatusData[0] && scorecardFiltersData.StatusData[0].DID > 0 ){
              selectedId.Dealers = l_response[0][0].SelectedDealerID;
            }

            if(props.ScreenID == -3000){
              selectedId.Dealers = l_response[0][0].SelectedDealerID;
            }
          }

          sendResponseToParent();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
        setShowAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function sendResponseToParent() {
    if (
      selectedId.Dealers > 0 ||
      selectedId.Months > 0 ||
      selectedId.Years > 0
    ) {
      if (
        selectedId.Quarter !== prevQuarter.current ||
        selectedId.Years !== prevYear.current ||
        selectedId.Dealers !== prevDealers.current
      ) {
       // AppContext.ScoreCardFiltersIDs = selectedId;
        props.MainTopFiltersCallBack(selectedId);
      }
      prevQuarter.current = selectedId.Quarter;
      prevYear.current = selectedId.Years;
      prevDealers.current = selectedId.Dealers;
    }
  }

  return (
    <>
   {showAnimation && <LoadingAnimation/>}
    {scorecardFiltersData.StatusData[0] && scorecardFiltersData.StatusData[0] && scorecardFiltersData.StatusData[0]["DID"] == 0  &&  <div>
        <select
          className="input-field select-field"
          value={selectedId.Dealers}
          onChange={(e) =>
            setSelectedId((prevState: any) => ({
              ...prevState,
              Dealers: e.target.value,
            }))
          }
        >
          {props.ScreenID != -3000 &&  <option value={0}>All Importers</option>}
          {scorecardFiltersData.Dealers &&
            scorecardFiltersData.Dealers.map((Item: any, index:any) => (
              <option value={Item.PID} key={"Dealers" + Item.PID}>
                {Item.Name}
              </option>
            ))}
        </select>
      </div>
      }
      <div>
        <select
          className="input-field select-field"
          value={selectedId.Years}
          onChange={(e) =>
            setSelectedId((prevState: any) => ({
              ...prevState,
              Years: e.target.value,
            }))
          }
        >
          {scorecardFiltersData.Years &&
            scorecardFiltersData.Years.map((Item: any, index:any) => (
              <option value={Item.PID} key={"Years" + Item.PID}>
                {Item.Name}
              </option>
            ))}
        </select>
      </div>

        <div>
          <select
            className="input-field select-field"
            value={selectedId.Quarter}
            onChange={(e) =>
              setSelectedId((prevState: any) => ({
                ...prevState,
                Quarter: e.target.value,
              }))
            }
          >
            {scorecardFiltersData.Quarter &&
              scorecardFiltersData.Quarter.map((Item: any, index:any) => (
                <option value={Item.PID} key={"Quarter" + Item.PID}>
                  {Item.Name}
                </option>
              ))}
          </select>
        </div>

    </>
  );
}

export default React.memo(MainTopFilters);
